import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth, db } from "../firebase";
import { doc, getDoc, getDocs, query, collection, where } from "firebase/firestore";


function Menu() {
    const [username, setUsername] = useState("Guest");
    const [userData, setUserData] = useState(null);
    const [propertyStatus, setPropertyStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [propertyName, setPropertyName] = useState("");
    const [propertyLogo, setPropertyLogo] = useState("");
    const [documentStatus, setDocumentStatus] = useState(null);
    const [openMenu, setOpenMenu] = useState(null);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!userData) return;

                const userRef = doc(db, "authroles", userData.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const user = userSnap.data();
                    setUsername(user.name || "Guest");

                    if (user.propertyId) {
                        fetchPropertyAndDocuments(user.propertyId);
                        fetchPropertyDetails(user.propertyId);
                    } else {
                        setDocumentStatus("pending");
                        setPropertyStatus("no-property");
                    }

                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [userData]);

    const fetchPropertyDetails = async (propertyId) => {
        try {
            const propRef = doc(db, "properties", propertyId);
            const propSnap = await getDoc(propRef);

            if (propSnap.exists()) {
                const propData = propSnap.data();

                setPropertyStatus(propData.status || null);
                setPropertyName(propData.hotelname || "");
                setPropertyLogo(propData.logo || "");

                if (propData.status === "Deactivate") {
                    window.location.href = "/disabled-property";
                    return;
                }
            } else {
                setPropertyStatus("not-found");
            }
        } catch (err) {
            console.error("Error fetching property:", err);
        }
    };

    const fetchPropertyAndDocuments = async (propertyId) => {
        try {
            /* ---------- PROPERTY ---------- */
            const propRef = doc(db, "properties", propertyId);
            const propSnap = await getDoc(propRef);

            if (propSnap.exists()) {
                const propData = propSnap.data();
                setPropertyName(propData.hotelname || "");
                setPropertyLogo(propData.logo || "");

                if (propData.status === "Deactivate") {
                    window.location.href = "/disabled-property";
                    return;
                }
            }

            /* ---------- DOCUMENTS ---------- */
            const docsQuery = query(
                collection(db, "documents"),
                where("propertyId", "==", propertyId)
            );


            const docsSnap = await getDocs(docsQuery);

            if (!docsSnap.empty) {
                const docsData = docsSnap.docs[0].data();
                setDocumentStatus(docsData.status); // ✅ approved / pending / rejected
            } else {
                setDocumentStatus("pending");
            }

        } catch (err) {
            console.error("Error fetching property/documents:", err);
            setDocumentStatus("pending");
        } finally {
            setLoading(false);
        }
    };


    // ------------------------------
    //   STYLES
    // ------------------------------

    const linkStyle = {
        color: "#fff",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "15px 15px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        borderBottom: "1px solid rgba(245, 238, 238, 0.2)",
        cursor: "pointer",
        position: "relative"
    };

    const linkHover = {
        background: "rgba(255,255,255,0.15)",
        transform: "translateX(6px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(255,255,255,0.07)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
        display: "block"
    };

    const iconStyle = {
        fontSize: "20px",
        width: "45px",
        textAlign: "center"
    };

    const arrowIconStyle = {
        marginLeft: "auto",
        transition: "0.3s",
        fontSize: "14px"
    };

    const firstLetter = username.charAt(0).toUpperCase();

    // ------------------------------
    //   MENU STRUCTURE
    // ------------------------------



    const fullMenu = [
        {
            icon: "fas fa-boxes",
            text: "Cleaning",
            submenu: [
                { text: "Cleaning Rooms", link: "/cleaning-rooms" },
                { text: "Cleaned Rooms", link: "/cleaned-rooms" },
                { text: "Live Rooms", link: "/view-reservations" },
            ]
        },
        { icon: "fas fa-life-ring", text: "Help & Support", link: "/help-support" }
    ];


    const menuToShow =
        propertyStatus === "Active"
            ? fullMenu : fullMenu


    return (
        <aside
            className="main-sidebar"
            style={{
                background: "linear-gradient(180deg, #2a0845 0%, #6441A5 50%, #2a0845 100%)",
                backgroundImage: "url('/back.jpg')",
                backgroundBlendMode: "overlay",
                backgroundSize: "cover",
                color: "#fff",
                minHeight: "100vh",
                width: "250px",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                display: "flex",
                flexDirection: "column"
            }}
        >

            {/* TOP PROFILE BAR */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                    position: "sticky",
                    top: 0,
                    background: "rgba(30,0,60,0.8)",
                    backdropFilter: "blur(6px)",
                    zIndex: 10
                }}
            >
                {propertyLogo ? (
                    <img
                        src={propertyLogo}
                        alt="Property Logo"
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            margin: "0 auto 10px auto",
                            display: "block",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            background: "#fff"
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            fontWeight: "700",
                            margin: "0 auto 10px auto",
                            color: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                        }}
                    >
                        {firstLetter}
                    </div>
                )}


                <h5 style={{ fontWeight: "600", margin: 0 }}>{username}</h5>

                {propertyName && (
                    <p style={{
                        fontSize: "13px",
                        margin: "4px 0 0",
                        color: "#e0e0ff",
                        fontWeight: "500"
                    }}>
                        {propertyName}
                    </p>
                )}

            </div>

            {/* MENU AREA */}
            <div
                style={{
                    padding: "5px 1px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,
                    scrollbarWidth: "thin",          // Firefox
                    scrollbarColor: "#9f7aea transparent" // Firefox
                }}
                className="sidebar-scroll"
            >

                {menuToShow.map((item, index) => (
                    <div
                        key={index}
                        className="menu-parent"
                        style={{ position: "relative" }}

                    >

                        <motion.a
                            href={item.link || "#"}
                            style={linkStyle}
                            whileHover={linkHover}
                            onClick={(e) => {
                                if (item.submenu) {
                                    e.preventDefault();
                                    setOpenMenu(openMenu === index ? null : index);
                                }
                            }}
                        >
                            <i className={item.icon} style={iconStyle}></i>
                            <span>{item.text}</span>

                            {item.submenu && (
                                <i
                                    className="fas fa-chevron-right arrow-icon"
                                    style={{
                                        ...arrowIconStyle,
                                        transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                    }}
                                ></i>
                            )}
                        </motion.a>


                        {item.submenu && openMenu === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    overflow: "hidden",
                                }}
                            >
                                {item.submenu.map((sub, sIndex) => (
                                    <motion.a
                                        key={sIndex}
                                        href={sub.link}
                                        style={{ ...linkStyle, ...submenuStyle }}
                                        whileHover={linkHover}
                                    >
                                        • {sub.text}
                                    </motion.a>
                                ))}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}

export default Menu;
